import React from 'react';
import { Input } from '../common/_forms';
import { NavLink } from 'react-router-dom';
const ForgotPasswordPage = (props) => {
    const { state, error, handleChange, handleSubmit } = props;
    return (
        <div className="login-ext">
            <div className="logo">
                <NavLink to="/"><img src="/assets/images/left-menu-logo1.png" alt="Logo" /></NavLink>
            </div>
            <div className="d-table d-table__middle">
                <div>
                    <form name="loginForm" autoComplete="off" onSubmit={handleSubmit}>
                        <div className="center-content">
                            <h2>Forgot Password?</h2>
                            <p><b>Let Us Help You. Please Provide below Details.</b></p>
                            {/* <div className="form-group custom">
                                <Input
                                    label="Customer Code"
                                    type="text"
                                    name="companyCode"
                                    value={state.customerCode}
                                    error={error.message('companyCode', state.companyCode, 'required')}
                                    controlFunc={e => handleChange(e)}
                                />
                            </div> */}
                            <div className="form-group custom">
                                <Input
                                    label="Email"
                                    type="email"
                                    name="email"
                                    value={state.email}
                                    error={error.message('email', state.email, 'required|email')}
                                    controlFunc={e => handleChange(e)} />
                            </div>
                            <button type="submit" className="btn btn-block mb-4">Send Request</button>
                            <p className="link">or<NavLink to="/login"> Login Here</NavLink></p>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
export default ForgotPasswordPage;